import { ajaxSend } from '../../../api/api';
const baseV2 = '/v2/presence';
export function presenceGetTotal(params = {}) {
    return ajaxSend({
        params,
        path: `${baseV2}/total`,
    });
}
export function presenceGetAll(params = {}) {
    return ajaxSend({
        params,
        path: baseV2,
    });
}
